export const OUTBOUND_DEALS_COLUMNS = [
  { name: 'id',                      label: 'ID' },
  { name: 'payments.created_at',     label: 'Created At' },
  { name: 'payments.paid_at',        label: 'Paid At' },
  { name: 'deals.pickup_at',         label: 'Pickup At' },
  { name: 'deals.reference_number',  label: 'Order Number' },
  { name: 'deals.created_deal_by',    label: 'Create Deal By' },
  { name: 'users.email',             label: 'User Email' },
  { name: 'user_details.name',       label: 'Customer Name' },
  { name: 'user_details.phone',      label: 'Phone Number' },

  {
    name: 'products.sku_list',
    label: 'SKU(s) List / Items inside Deal',
    thStyle: { minWidth: 280, width: 320 },
    tdStyle: { minWidth: 280, width: 320, whiteSpace: 'pre-line' }
  },

  { name: 'deals.final_payment',     label: 'Final Payment' },
  { name: 'deals.total_quantity',    label: 'Qty' },
  {
    name: 'deals.authentication_status_summary',
    label: 'Authentication',
    thStyle: { minWidth: 220, width: 260 },
    tdStyle: { minWidth: 220, width: 260, whiteSpace: 'pre-line' }
  },
  { name: 'deals.down_payment',      label: 'Down Payment' },

  {
    name: 'payments.method_type',
    label: 'Payment Method',
    thStyle: { minWidth: 180, width: 200 },
    tdStyle: { minWidth: 180, width: 200 }
  },

  { name: 'deals.state',             label: 'State' },
  { name: 'deals.note',              label: 'Catatan' },
]
